import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AcceptanceCancelledPage() {
  const navigate = useNavigate();
  return (
    <div
      className="max-w-md mx-auto px-6 py-20 text-center"
      data-testid="acceptance-cancelled-page"
    >
      <div className="overline">Payment cancelled</div>
      <h1 className="font-display text-3xl text-[var(--emerald)] mt-3">
        No worries — your trip is still saved.
      </h1>
      <p className="text-sm text-[var(--ink-2)] mt-4 leading-relaxed">
        You stepped away from the payment without completing the deposit. Your
        itinerary is still queued with Sasha and you can return any time to
        lock it in.
      </p>
      <div className="mt-8 flex justify-center gap-3 flex-wrap">
        <button
          onClick={() => navigate(-1)}
          className="btn-primary"
          data-testid="acceptance-cancelled-back"
        >
          <ArrowLeft size={14} strokeWidth={1.5} /> Back to itinerary
        </button>
        <button
          onClick={() => navigate("/")}
          className="text-xs uppercase tracking-[0.18em] text-[var(--brand-red)] hover:text-[var(--emerald)] px-3 py-2 self-center"
          data-testid="acceptance-cancelled-home"
        >
          Back to Sasha
        </button>
      </div>
    </div>
  );
}
